export default function calculateLines(lines, xScale, yScale, nodeRadius) {
	let result = [];
	let turnScale = Math.min(xScale, yScale, 40)/4;
	for (let line of lines) {
		let startX = line.from.x * xScale;
		let startY = line.from.y * yScale + nodeRadius - 1;
		let endX = line.to.x * xScale;
		let endY = line.to.y * yScale - nodeRadius + 1;

		let d = `M ${startX},${startY}`;
		let prevX = startX;
		for (let via of line.via) {
			d += calculateLineCore(prevX, via.x * xScale, via.y * yScale - nodeRadius + 1, turnScale);
			prevX = via.x * xScale;
		}
		d += calculateLineCore(prevX, endX, endY, turnScale);

		result.push({
			subOrder: line.subOrder || {},
			d: d
		});
	}
	return result;
}

function calculateLineCore(startX, endX, endY, turnScale) {
	let d = '';
	if (startX === endX) { // Straight line
		d += ` L ${endX},${endY}`;
	} else if (startX < endX) { // Branch off to the right
		d += ` q 0,${turnScale} ${turnScale},${turnScale}`;
		d += ` l ${endX - startX - turnScale*2},0`;
		d += ` q ${turnScale},0 ${turnScale},${turnScale}`;
		d += ` L ${endX},${endY}`;
	} else { // Merge back left
		d += ` L ${startX},${endY-turnScale*2}`;
		d += ` q 0,${turnScale} -${turnScale},${turnScale}`;
		d += ` l -${startX - endX - turnScale*2},0`;
		d += ` q -${turnScale},0 -${turnScale},${turnScale}`;
	}
	return d;
}